import { createEntityAdapter, createSelector } from "@reduxjs/toolkit";
import { apiSlice } from "../../apiSlice";

/* ================= ENTITY ADAPTER ================= */

const bulkSpareSellerAdapter = createEntityAdapter({
  selectId: (seller) => seller.id,
});

const initialState = bulkSpareSellerAdapter.getInitialState();

/* ================= API INJECTION ================= */

export const bulkSpareSellerApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBulkSpareSellerList: builder.query({
      query: () => "bulk_deals/spares/sellers",

      transformResponse: (response) => {
        const sellers = response?.data ?? [];

        return bulkSpareSellerAdapter.setAll(initialState, [
          { id: "", label: "Select Seller" }, // default option
          ...sellers,
        ]);
      },

      providesTags: (result) =>
        result
          ? [
              { type: "BulkSpareSellerList", id: "LIST" },
              ...result.ids.map((id) => ({
                type: "BulkSpareSeller",
                id,
              })),
            ]
          : [{ type: "BulkSpareSellerList", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

/* ================= HOOK EXPORT ================= */

export const {
  useGetBulkSpareSellerListQuery,
} = bulkSpareSellerApi;

/* ================= RTK QUERY SELECTOR ================= */

const selectBulkSpareSellerResult =
  bulkSpareSellerApi.endpoints.getBulkSpareSellerList.select();

/* ================= NORMALIZED DATA ================= */

const selectBulkSpareSellerData = createSelector(
  [selectBulkSpareSellerResult],
  (sellerResult) => sellerResult?.data ?? initialState
);

/* ================= ENTITY SELECTORS ================= */

export const {
  selectAll: selectAllBulkSpareSellers,
  selectById: selectBulkSpareSellerById,
  selectIds: selectBulkSpareSellerIds,
} = bulkSpareSellerAdapter.getSelectors(
  (state) => selectBulkSpareSellerData(state)
);